import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "rightbar-sources" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (source, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "source"
      }, [
        _createElementVNode("div", {
          class: "head pointer",
          onClick: $event => (_ctx.$utils.openLink(source.url))
        }, [
          _createElementVNode("img", {
            src: source.icon,
            class: "image"
          }, null, 8 /* PROPS */, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(source.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, _toDisplayString($options.makeDate(source.date)), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_2),
        _createElementVNode("div", _hoisted_6, _toDisplayString(source.text), 1 /* TEXT */)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}